import { useContext, useState } from "react"
import NoProfileImage from "../../Components/NoProfileImage"
import UserContext from "../../Context/UserContext"
import {TbPencil} from 'react-icons/tb'
import Modal from "../../Components/Modal"
import { upload } from "../../Requests/firebaseStorage"
import { MdDelete } from "react-icons/md"
import AreYouSure from "../../Components/AreYouSure"
import { deleteGroupsDocWhereExhibitor, deleteInvitesDocWhereExhibitor, deleteUserDoc } from "../../Requests/firebaseFirestore"
import { deleteUserProfile, reauthentucate } from "../../Requests/firebaseAuth"
import { useNavigate } from "react-router-dom"
export default function ProfilePage(){
  const {user} = useContext(UserContext)
  const [imageModal, setImageModal] = useState(false)
  const [image, setImage] = useState(null)
  const [loadingImage, setLoadingImage] = useState(false)
  const [error, setError] = useState('')
  const [sureModal, setSureModal] = useState(false)
  const [signInModal, setSignInModal] = useState(false)
  const [signIn, setSignIn] =useState({email:'', password:''})
  const [signError, setSignError] = useState('')
  const [deleting, setDeleting] = useState(false)
  const navigate = useNavigate()
  const handleImageModal = () => {
    setImageModal(!imageModal)
  }
  const handleInputChange = (e) => {
    if(e.target.files[0]){
      if(e.target.files[0].size>46800){
        setError('el tamaño máximo es 45kb')
      }
      else{
        setError('')
        setImage(e.target.files[0])
      }
    }
  }

  const handleSureModal = async (res) => {
    if(res==='accepted'){

     handleSignInModal()
    }
    setSureModal(!sureModal)
  } 

  const handleSubmit = async (e) => {
    setLoadingImage(true)
    e.preventDefault()
    await upload(image, user.uid)
    handleImageModal(!imageModal)
    setLoadingImage(false);
    window.location.reload()
  }

  const handleSignInModal = () => {
    setSignInModal(!signInModal)
  }

  const handleSignInInput = (e) => {
    setSignError('')
    const {name, value} = e.target
    setSignIn({...signIn, [name]:value})
  }

  const handleSignInSubmit = async (e) => {
    setDeleting(true)
    e.preventDefault()
    const res = await reauthentucate(signIn)
    if(res.status==='failed'){
      setSignError('Los datos ingresados no son correctos')
    }else{
      if(user.role!=='staff'){
        await deleteGroupsDocWhereExhibitor(user.uid)
      }
      await deleteInvitesDocWhereExhibitor(user.email)
      await deleteUserDoc(user.uid)
      await deleteUserProfile()
      handleSignInModal()
    }
    setDeleting(false)
  }

  return <div className="container mx-auto px-4 flex flex-col justify-center gap-y-3">
    <h1 className="text-stone-600 font-semibold text-xl py-2 mx-auto">Mi perfil</h1>
    <div className="relative w-fit mx-auto profile-image-xl">
      {user.imageUrl===''?
      <div className="rounded-[50%] ring-4 ring-offset-4 ring-rose-600 w-[150px] mx-auto picture">
        <NoProfileImage size={150}/>
      </div>
        :
      <img className="rounded-[50%] ring-4 ring-offset-4 ring-rose-600 w-[150px] h-[150px] mx-auto picture object-cover" alt="profile" src={user.photoURL}/>
      }
      <div onClick={handleImageModal} className="cursor-pointer absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-[50%] opacity-0 hover:opacity-100 flex justify-center items-center duration-200 bg-black bg-opacity-25 text-white flex-col"><TbPencil size={25}/><span>Editar</span></div>
    </div>
    <h1 className="mx-auto text-xl">{user.displayName}</h1>
    <div className="border border-stone-400 w-1/2 min-w-[350px] max-w-[400px] mx-auto rounded-[10px] divide-y flex flex-col py-2 px-3">
    <div className="flex justify-between items-center ">
        <span className="">Email:</span>
        <span className=" py-2 px-3">{user.email}</span>
      </div>
      <div className="flex justify-between items-center">
        <span className="">Empresa:</span>
        <span className=" py-2 px-3">{user.company}</span>
      </div>
    </div>
    <button className="border-2 rounded-[10px] py-2 px-3 mx-auto mt-4 border-red-500 text-red-500 hover:text-white hover:bg-red-500 active:bg-red-700 duration-150 flex w-fit" onClick={()=>{handleSureModal()}}><MdDelete size={25}/> Eliminar cuenta</button>
    <Modal isActive={imageModal} handle={handleImageModal} title='Cambiar imagen de perfil'>
      <form className="flex flex-col justify-center gap-4" onSubmit={handleSubmit}>
        <div className="input-holder">
          <input type="file" name="profile-image" id="profile-image" required onChange={handleInputChange}/>
        {error!==''?<span className="text-red-500">{error}</span>:<></>}
        </div>
        <button className=" send-btn" disabled={loadingImage || error!==''}>{loadingImage?'Cargando...':'Guardar'}</button>
      </form>
    </Modal>
    <Modal isActive={signInModal} handle={handleSignInModal} title='Confirmar identidad'>
      <form onSubmit={handleSignInSubmit} className='flex flex-col gap-4 w-full'>
        <div className="input-holder w-[75%]">
          <input type="email" name="email" id='sign-in-email' value={signIn.email} onChange={handleSignInInput} required/>
          <label htmlFor="sign-in-email">Email</label>
        </div>
        <div className="input-holder w-[75%]">
          <input type="password" name="password" id='sign-in-password' value={signIn.password} onChange={handleSignInInput} required/>
          <label htmlFor="sign-in-password">Contraseña</label>
        </div>
        {signError===''?<></>:
        <span className="mx-auto text-red-500">{signError}</span>}
        <button className="send-btn" disabled={deleting}>{deleting?'Borrando...':'Borrar cuenta'}</button>
      </form>
    </Modal>
    <AreYouSure isActive={sureModal} handle={handleSureModal} title='¿Eliminar cuenta?'/>
  </div>
}